import React, { useState } from 'react'
import FlexView from 'react-flexview'
import { ActiveInsuranceModel } from '../../../../models/insurance-models/ActiveInsuranceModel'
import { ReactComponent as AICircle } from '../../../../assets/ai.svg'
import { ReactComponent as PersonCircle } from '../../../../assets/person_with_circle.svg'
import { Dialog } from '@material-ui/core'
import CircledPopUpFrame from '../../../Core/CircledPopUpFrame'
import { AdditionalInsuredForm } from '../../../AdditionalInsured/AdditionalInsuredForm'
import { isMobile } from 'react-device-detect'
import {
    EventEmitterService,
    EventKey,
} from '../../../../services/EventEmitterService'
import { SkywatchDialog } from '../../../PopUps/SkywatchDialog'
import { AdditionalInsuredPolicyView } from '../../../AdditionalInsured/AdditionalInsuredPolicyView'
import { useLocation } from 'react-router-dom'
import DataLayerService from '../../../../services/DataLayerService'
import {
    FirebaseConfigKey,
    FirebaseService,
} from '../../../../services/FirebaseService'

var classNames = require('classnames')

interface PolicyAdditionalInsuredSectionProps {
    insurance: ActiveInsuranceModel;
}

export const PolicyAdditionalInsuredSection = ({
    insurance,
}: PolicyAdditionalInsuredSectionProps) => {
    const location = useLocation()
    const [aiDialogOpen, setAiDialogOpen] = useState(!!location.state.open_ai)

    const showModifyAI = () => {
        setAiDialogOpen(true)
        DataLayerService.pushToDataLayer({
            event: 'additional-insured-open',
            at: window.location.pathname,
        })
    }

    const closeModifyAI = () => {
        setAiDialogOpen(false)
    }

    React.useEffect(() => {
        let id = EventEmitterService.subscribe(
            EventKey.ADDITIONAL_INSURED_FINISH,
            closeModifyAI
        )

        return function cleanup() {
            EventEmitterService.unsubscribe(
                EventKey.ADDITIONAL_INSURED_FINISH,
                id
            )
        }
    }, [])

    return (
        <React.Fragment>
            <FlexView className="space-between">
                <div className="black text-body bold">Additional Insured</div>
                {/* {insurance.isActiveOrSchedule() && <div onClick={showModifyAI} className="underline clickable blue bold text-small">Modify</div>} */}
            </FlexView>
            <FlexView
                column={isMobile}
                className={classNames(
                    { 'space-between': !isMobile },
                    'margin-top-small'
                )}
            >
                <div className="black text-small">
                    {/* {insurance.additionalInsuredList?.map( (ai, index) => <AdditionalInsuredPolicyView key={index} ai={ai} />)} */}
                    Insured Name: {insurance.additionalInsuredName}
                </div>
                <div className="gray margin-top-small text-tiny">
                    Premium:{' '}
                    {FirebaseService.getValue(
                        FirebaseConfigKey.CURRENCY_SYMBOL
                    )}
                    {insurance.additionalInsuredPrice}
                </div>
            </FlexView>
            <SkywatchDialog
                fullScreen={isMobile}
                open={aiDialogOpen}
                closeDialog={closeModifyAI}
                circleHeader={<PersonCircle />}
                closeTitle="Additional Insured"
                maxWidth={'xs'}
            >
                <AdditionalInsuredForm insurance={insurance} />
            </SkywatchDialog>
        </React.Fragment>
    )
}
